import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { useFormikContext, ErrorMessage } from "formik";
import { getInsurance } from "../services/apiService";

const InsurerDropdown = ({ name = "insurer", insurerType, onChange }) => {
  const [insurers, setInsurers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setFieldValue, values } = useFormikContext();

  useEffect(() => {
    const fetchInsurers = async () => {
      try {
        setLoading(true);
        const response = await getInsurance({ Insurer_Type: insurerType });
        console.log("API Response:", response);

        if (response && response.data) {
          setInsurers(response.data);
        } else {
          setInsurers([]);
        }
      } catch (error) {
        console.error("Error fetching insurers:", error);
        setInsurers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchInsurers();
  }, [insurerType]);

  // Convert to react-select options
  const options = useMemo(() => {
    return insurers.map((item) => ({
      value: item.Insurer_ID,
      label: item.Insurer_Name,
    }));
  }, [insurers]);

  const selectedValue =
    options.find((option) => option.value === values[name]) || null;

  const handleChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setFieldValue(name, value);
    if (onChange) onChange(value);
  };

  return (
    <div className="px-2">
      <label className="form-label">
        Insurer <span className="text-danger">*</span>
      </label>

      <Select
        name={name}
        options={options}
        value={selectedValue}
        onChange={handleChange}
        isLoading={loading}
        isSearchable
        isClearable
        placeholder={loading ? "Loading insurers..." : "Select Insurer"}
        styles={{
          control: (base, state) => ({
            ...base,
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
            border: state.isFocused ? "1px solid #EB2B21" : "1px solid #D1D5DB",
            borderRadius: "10px",
            padding: "2px 2px",
            fontSize: "14px",
            outline: "none",
            "&:hover": {
              borderColor: state.isFocused ? "#EB2B21" : "#9ca3af",
            },
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: "10px",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.15)",
          }),
        }}
      />

      <ErrorMessage
        name={name}
        component="div"
        className="text-red-600 text-sm mt-1"
      />
    </div>
  );
};

export default InsurerDropdown;
